import type { UserCard } from '@/features/auth/types'
import { api } from '@/shared/api'

/** Приглашение в партию — то, что видит приглашённый. */
export type Invite = {
  id: number
  gameId: string
  from: string
  players: number
  at: string | null
}

export async function fetchFriends(): Promise<UserCard[]> {
  const { data } = await api.get<{ friends: UserCard[] }>('/friends')

  return data.friends
}

export async function fetchRequests(): Promise<{ incoming: UserCard[]; outgoing: UserCard[] }> {
  const { data } = await api.get<{ incoming: UserCard[]; outgoing: UserCard[] }>(
    '/friends/requests',
  )

  return data
}

export async function searchUsers(query: string): Promise<UserCard[]> {
  const { data } = await api.get<{ users: UserCard[] }>('/users/search', { params: { q: query } })

  return data.users
}

export async function addFriend(nickname: string): Promise<UserCard> {
  const { data } = await api.post<UserCard>('/friends', { nickname })

  return data
}

export async function acceptFriend(userId: number): Promise<void> {
  await api.post(`/friends/${userId}/accept`)
}

/** Убрать из друзей, отклонить заявку или отозвать свою — одно и то же. */
export async function removeFriend(userId: number): Promise<void> {
  await api.delete(`/friends/${userId}`)
}

export async function fetchInvites(): Promise<Invite[]> {
  const { data } = await api.get<{ invites: Invite[] }>('/me/invites')

  return data.invites
}

export async function declineInvite(inviteId: number): Promise<void> {
  await api.delete(`/invites/${inviteId}`)
}

export async function inviteToGame(gameId: string, userId: number): Promise<void> {
  await api.post(`/games/${gameId}/invites`, { userId })
}
